export default class ApplicationFormValidation {

    constructor(formSelector = '#bewerbung', hostSelector = '#form-host') {

        this.form = document.querySelector(formSelector);
        this.host = document.querySelector(hostSelector);

        if (!this.form) {
            // Kein Formular auf der Seite → normal, wenn global eingebunden
            return;
        }

        // Inputs
        this.fileInput = this.form.querySelector('#file');
        this.drop = this.form.querySelector('#drop');
        this.fileMeta = this.form.querySelector('#file-meta');

        // Methoden binden
        this.validateField = this.validateField.bind(this);
        this.validateAll = this.validateAll.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.init();
    }

    // -------------------------
    // INIT
    // -------------------------
    init() {
        this.setupDragAndDrop();
        this.bindInputValidation();
        this.form.addEventListener('submit', this.handleSubmit);
    }

    // -------------------------
    // Drag & Drop
    // -------------------------
    setupDragAndDrop() {
        if (!this.drop) return;

        ['dragenter', 'dragover'].forEach(ev =>
            this.drop.addEventListener(ev, (e) => {
                e.preventDefault();
                this.drop.style.background = '#fff8f5';
            })
        );

        ['dragleave', 'drop'].forEach(ev =>
            this.drop.addEventListener(ev, (e) => {
                e.preventDefault();
                this.drop.style.background = '#faf6f3';
            })
        );

        this.drop.addEventListener('drop', (e) => {
            if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                this.fileInput.files = e.dataTransfer.files;
                this.renderFileMeta();
                this.validateField(this.fileInput);
            }
        });

        this.fileInput.addEventListener('change', () => {
            this.renderFileMeta();
            this.validateField(this.fileInput);
        });
    }

    renderFileMeta() {
        const f = this.fileInput.files[0];
        this.fileMeta.textContent = f ? `${f.name} • ${(f.size / 1024 / 1024).toFixed(2)} MB` : '';
    }

    // -------------------------
    // Scroll Helfer
    // -------------------------
    scrollToFormStart() {
        const target = this.host || this.form;
        if (!target) return;

        const rect = target.getBoundingClientRect();
        const offsetTop = window.pageYOffset + rect.top;

        window.scrollTo({
            top: offsetTop - 40, // ggf. Header-Höhe anpassen
            behavior: 'smooth'
        });
    }

    // -------------------------
    // Feldvalidierung
    // -------------------------
    bindInputValidation() {
        const ids = ['vorname', 'nachname', 'email', 'telefon', 'quelle'];

        ids.forEach(id => {
            const el = this.form.querySelector('#' + id);
            if (!el) return;

            el.addEventListener('blur', () => this.validateField(el));
            el.addEventListener('input', () => this.clearError(el));
        });

        // DSGVO Checkboxen
        ['ds1', 'ds2', 'ds3'].forEach(id => {
            const el = this.form.querySelector('#' + id);
            if (!el) return;

            el.addEventListener('change', () => this.validateField(el));
        });
    }

    // -------------------------
    // Hilfsfunktionen
    // -------------------------
    $(s, r = document) { return r.querySelector(s); }

    setError(input, msg) {
        input.classList.add('is-error');
        input.setAttribute('aria-invalid', 'true');

        const err = document.querySelector('#err-' + input.id);
        if (err) {
            err.textContent = msg || '';
            err.classList.add('is-error');
        }
    }
    clearError(input) {
        input.classList.remove('is-error');
        input.removeAttribute('aria-invalid');

        const err = document.querySelector('#err-' + input.id);
        if (err) {
            err.textContent = '';
            err.classList.remove('is-error');
        }
    }

    // -------------------------
    // Validierungslogik
    // -------------------------
    validators = {
        vorname: (v) => v.trim().length >= 2 || 'Bitte geben Sie einen gültigen Vornamen ein.',
        nachname: (v) => v.trim().length >= 2 || 'Bitte geben Sie einen gültigen Nachnamen ein.',
        email: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) || 'Bitte eine gültige E-Mail-Adresse eingeben.',
        telefon: (v) => {
            if (!v.trim()) return true; // optional
            const clean = v.replace(/[^\d]/g, '');
            const okStart = v.trim().startsWith('+49') || v.trim().startsWith('0');
            const okChars = /^[0-9+\s\-\(\)]+$/.test(v);
            return (okStart && okChars && clean.length >= 7 && clean.length <= 15) || 'Bitte eine gültige deutsche Telefonnummer eingeben.';
        },
        quelle: () => true,
        file: (file) => {
            if (!file) return 'Bitte ein PDF hochladen.';
            const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
            const sizeOk = file.size <= 10 * 1024 * 1024;
            if (!isPdf) return 'Es sind nur PDF-Dateien erlaubt.';
            if (!sizeOk) return 'Die Datei darf maximal 10 MB groß sein.';
            return true;
        },
        checkbox: (checked) => checked || 'Bitte ankreuzen (Pflichtfeld).'
    }

    validateField(el) {
        const id = el.id;
        let result;

        if (id === 'file') {
            result = this.validators.file(el.files[0]);
        }
        else if (id.startsWith('ds')) {
            result = this.validators.checkbox(el.checked);
        }
        else {
            result = this.validators[id] ? this.validators[id](el.value) : true;
        }

        if (result === true) {
            this.clearError(el);
            return true;
        }

        this.setError(el, result);
        return false;
    }

    validateAll() {
        const textFields = ['vorname', 'nachname', 'email', 'telefon', 'quelle'];
        const checks = ['ds1', 'ds2', 'ds3'];

        const validText = textFields.every(id => this.validateField(this.form.querySelector('#' + id)));
        const validFile = this.validateField(this.fileInput);
        const validChecks = checks.every(id => this.validateField(this.form.querySelector('#' + id)));

        // Honeypot
        const bot = this.form.querySelector('#website').value.trim().length > 0;
        if (bot) return false;

        return validText && validFile && validChecks && !bot;
    }

    // -------------------------
    // Submit + AJAX
    // -------------------------
    async handleSubmit(e) {
        e.preventDefault();

        if (!this.validateAll()) return;

        // -------------------------
        // LOCAL TEST (kein Versand)
        // -------------------------
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {

            this.scrollToFormStart();

            this.host.innerHTML = `
                <div class="success success-fade" id="success-message">
                  <p><strong>Test: Bewerbung erfolgreich übermittelt.</strong></p>
                  <p>Dies ist eine lokale Testmeldung (kein echter Versand).</p>
                </div>
            `;

            requestAnimationFrame(() => {
                const box = document.querySelector('#success-message');
                if (box) box.classList.add('is-visible');

                if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
                    window.ScrollTrigger.refresh();
                }
            });

            return;
        }

        // -------------------------
        // LIVE SENDEN
        // -------------------------
        const fd = new FormData(this.form);
        fd.append('_ajax', '1');

        const btn = this.form.querySelector('#submitBtn');
        const originalBtnText = btn ? btn.innerHTML : '';
        if (btn) {
            btn.disabled = true;
            btn.innerHTML = 'Wird gesendet…';
        }

        try {
            const res = await fetch(this.form.action, { method: 'POST', body: fd });
            const raw = await res.text();
            console.log('send.php raw response:', raw);

            let data;
            try {
                data = JSON.parse(raw);
            } catch (parseErr) {
                console.error('Antwort ist kein JSON', parseErr);
                throw new Error('Ungültige JSON-Antwort vom Server.');
            }

            if (!res.ok || !data.ok) {
                alert(data.message || 'Senden fehlgeschlagen. Bitte später erneut versuchen.');
                if (btn) {
                    btn.disabled = false;
                    btn.innerHTML = originalBtnText;
                }
                return;
            }

            // -------------------------
            // ERFOLG – FORMULAR ERSETZEN
            // -------------------------
            this.scrollToFormStart();

            this.host.innerHTML = `
                <div class="success success-fade text-center" id="success-message">
                    <h3>Vielen Dank für die Übermittlung Deiner Bewerbung.</h3>
                    <p>Wir melden uns schnellstmöglich bei Dir.</p>
                </div>
            `;

            requestAnimationFrame(() => {
                const box = document.querySelector('#success-message');
                if (box) box.classList.add('is-visible');

                if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
                    window.ScrollTrigger.refresh();
                }
            });

        } catch (err) {
            console.error('Fehler beim Senden des Formulars:', err);
            alert('Es ist ein Server- oder Netzwerkfehler aufgetreten. Bitte später erneut versuchen.');
            if (btn) {
                btn.disabled = false;
                btn.innerHTML = originalBtnText;
            }
        }
    }
}
